/**
 * 应用信息对象
 */
export interface AppInfo {
  app_id?: string
  app_key?: string
  app_name?: string
  app_type?: number
  logo?: string
  desc?: string
  access_url?: string
  callback_url?: string
  status?: number
  is_sandbox?: boolean,
  is_add_to_app_center?: boolean
  creator?: any,
  create_at?: number
}

/**
 * 平台功能
 */
export interface IAppFeature {
  function_id?: string
  function_name?: string
  desc?: string
  app_id?: string
  status?: number
  doc_url?: string
}

/**
 * App功能审核状态
 */
export enum EFeatureStatus {
  NoApply = -100, // 未申请
  Rejected = -1, // 被拒绝（旧管理后台）
  Refused = -2, // 被拒绝（新管理后台）
  Pending = 0, // 待审批
  Passed = 1 // 审核通过
}

/**
 * App IP
 */
export interface AppIP {
  ip?: string
}

/**
 * App 域名
 */
export interface AppDomain {
  domain?: string
}

export interface IAppUser {
  app_id: string
  userid: string
  username: string
  avatar: string
  is_admin: boolean
  create_at: number
  modify_at: number
}

export interface IAppOrder {
  billno: string
  openid: string
  service_id: string
  subject: string
  status: string
  csource: string
  ctime: number
  finish_time: number
  count: number
  total_fee: number
  category: string
}
